import React from 'react';
import cx from 'classnames';
import styles from '@/common/containers/UserIntro/styles.less';
import img from '@/common/assets/introFirst.png';
import rock from '@/common/assets/introFounderRock.png';
import nick from '@/common/assets/introFounderNick.png';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const First = () => {
  const { t } = useTranslation();
  const copyrightSup = <CopyrightSup />;
  return (
    <div className={cx(styles.screen, styles.first)}>
      <div className={styles.firstItem}>
        <h4 className={cx(styles.screenTitle, styles.firstTitle)}>
          {t('A helping hand during a difficult time...')}
        </h4>
        <div className={styles.firstBody}>
          <p>
            {t(
              'The emotional difficulty of dealing with the death of a loved one can be overwhelming.'
            )}
          </p>
          <br />
          <p>
            <Trans
              i18nKey="This situation is made even more challenging by having to deal with the multitude of administrative requirements needed to notify relevant persons and agencies of the death, apply for death benefits, and taking care of the personal affairs and estate management (PAEM<copyrightSup/>) requirements of the decedent. We wish to acknowledge the difficult time you are going through and sincerely empathize with your situation."
              components={{ copyrightSup }}
            />
          </p>
          <br />
          <p>
            {t(
              'This software tool was designed by us as a result of our own attempts to deal with these difficult and sometimes chaotic circumstances following the death of our own parents, friends, and loved ones.'
            )}
          </p>
          <br />
          <p>
            {t(
              'This tool incorporates the lessons we learned in trying to deal with these challenges during this difficult and emotional time. We trust this tool will help guide you through some of these challenges and ease some of the burdens of this difficult situation.'
            )}
          </p>
        </div>
        <div className={styles.firstCreators}>
          <div className={styles.firstCreatorsAvatars}>
            <img className={styles.firstCreatorsAvatar} src={rock} alt="" />
            <img className={styles.firstCreatorsAvatar} src={nick} alt="" />
          </div>
          <div>
            <p>
              {t('Sincerely,')} {t('Nick Ierfino and Rock Wiegand')}
            </p>

            <p>{t('Praedias founders')}</p>
          </div>
        </div>
      </div>
      <div className={cx(styles.firstItem, styles.firstImgContainer)}>
        <div className={styles.firstImgContainerBack} />
        <img
          className={styles.firstImgContainerImg}
          src={img}
          alt={t('a women')}
        />
      </div>
    </div>
  );
};

export default First;
